(function() {
  $(function() {
    return $.widget('custom.myUploader', {
      options: {
        plupload_options: null,
        add_btn: null,
        beforeInit: function() {
          return void 0;
        },
        onInit: function() {
          return void 0;
        }
      },
      default_plupload_opts: {
        runtimes: 'html5,flash,silverlight',
        flash_swf_url: 'bower_components/plupload/js/Moxie.swf',
        silverlight_xap_url: 'bower_components/plupload/js/Moxie.xap',
        multi_selection: true,
        max_file_size: '1000mb',
        max_file_count: 200,
        chunk_size: '1mb'
      },
      _init: function() {
        var id, plup_options, ref;
        if ((this.options.add_btn == null) || this.options.add_btn.length === 0) {
          throw Error('myUploader: you must specify an add_btn');
        }
        id = (new Date()).getTime() + '_add_btn';
        this.options.add_btn.attr('id', id);
        plup_options = $.extend(this.default_plupload_opts, (ref = this.options.plupload_options) != null ? ref : {});
        plup_options.browse_button = id;
        this.uploader = new plupload.Uploader(plup_options);
        if (this.options.beforeInit != null) {
          this.options.beforeInit(this.element, this.uploader);
        }
        this.uploader.init();
        this.uploader.bind('FilesAdded', (function(_this) {
          return function(up, files) {
            var last_file_group;
            last_file_group = null;
            $.each(files, function(i, file) {
              var next_file_group, row;
              next_file_group = file.name.match(/[^.]*/)[0];
              if (_this.options.addRowCallback != null) {
                return _this.options.addRowCallback(i, file);
              } else {
                row = "<tr id='" + file.id + "' data-file-group='" + next_file_group + "'> <td class='file-name-spacing'> <span class='nowrap' title='" + file.name + "'>" + file.name + "</span> </td> <td class='upload-status'> <div class='progress-green progress'> <div class='bar'></div> </div> </td> <td>" + (plupload.formatSize(file.size)) + "</td>";
                if (next_file_group !== last_file_group) {
                  row += "<td> <button class='btn btn-mini btn-danger upload-remove-file'> <i class='fas fa-trash-alt'></i> </button> </td> </tr>";
                } else {
                  row += '<td></td> </tr>';
                }
                last_file_group = next_file_group;
                return _this.element.find('.filelist').append(row);
              }
            });
            _this.calculateTotalFileSize();
            up.refresh();
            return up.start();
          };
        })(this));
        this.element.on('click', '.upload-remove-file', (function(_this) {
          return function(e) {
            var elem, file_group, file_rows, j, len, results, row;
            elem = $(e.target);
            file_group = elem.closest('tr').attr('data-file-group');
            file_rows = elem.closest('table').find('tr[data-file-group = "' + file_group + '"]');
            results = [];
            for (j = 0, len = file_rows.length; j < len; j++) {
              row = file_rows[j];
              id = $(row).attr('id');
              results.push(_this.uploader.removeFile(_this.uploader.getFile(id)));
            }
            return results;
          };
        })(this));
        this.uploader.bind('FilesRemoved', (function(_this) {
          return function(up, files) {
            var file, j, len;
            for (j = 0, len = files.length; j < len; j++) {
              file = files[j];
              _this.element.find("#" + file.id).remove();
            }
            return _this.calculateTotalFileSize();
          };
        })(this));
        this.uploader.bind('FileUploaded', (function(_this) {
          return function(up, file) {
            var elem;
            elem = _this.element.find('.filelist').find('#' + file.id + ' .upload-status .bar');
            return elem.animate({
              width: '100%'
            }, 2);
          };
        })(this));
        this.uploader.bind('UploadProgress', (function(_this) {
          return function(up, file) {
            var elem;
            elem = _this.element.find('.filelist').find('#' + file.id + ' .upload-status .bar');
            if (parseInt(file.percent) > 0) {
              return elem.animate({
                width: file.percent + '%'
              }, 2);
            }
          };
        })(this));
        this.uploader.bind('UploadComplete', (function(_this) {
          return function(up, files) {
            if (_this.options.onComplete != null) {
              _this.options.onComplete(_this.element, _this.uploader);
            }
            if (_this.options.plupload_options.onComplete != null) {
              return _this.options.plupload_options.onComplete(_this.element, _this.uploader);
            }
          };
        })(this));
        if (this.onInit != null) {
          return this.options.onInit(this.element, this.uploader);
        }
      },
      _create: function() {
        return void 0;
      },
      _setOption: function() {
        return void 0;
      },
      destroy: function() {
        return void 0;
      },
      getUploader: function() {
        return this.uploader;
      },
      calculateTotalFileSize: function() {
        var size;
        size = 0;
        $.each(this.uploader.files, (function(_this) {
          return function(i, file) {
            return size += file.size;
          };
        })(this));
        return this.element.find('.upload-total-size').html(plupload.formatSize(size));
      }
    });
  });

}).call(this);
